import { PARK_PORTFOLIO_KEY, PATH_OFFSHORE_ACTIVITY, PATH_OPERATIONS_COMMERCIAL, PATH_STATUS } from 'common/constants';
import { Logger } from 'common/logger';

export const getViewName = (permissionName) => {
    const parts = permissionName.split('-');

    const [, viewName] = parts;

    return viewName;
};

const parkToRoutes = ({ datasetName: parkName, permissions }) => {
    const routes = [];

    if (permissions?.includes('view-operations')) {
        routes.push({ url: `/${parkName}/operations` });
    }
    if (permissions?.includes('view-reports')) {
        routes.push({ url: `/${parkName}/reports` });
    }
    if (routes.length > 0) {
        routes.push({ url: `/${parkName}/${PATH_STATUS}` });
    }

    return routes;
};

const getAllowedScreens = (parkObject) => {
    return parkObject.reduce((acc, { permissions, datasetName: parkName }) => {
        const screens = [];

        if (permissions?.includes('view-operations')) {
            screens.push('operations');
        }
        if (permissions?.includes('view-reports')) {
            screens.push('reports');
        }

        if (screens.length > 0) {
            acc[parkName] = screens;
        }

        return acc;
    }, {});
};

export const privilegesToAppConfig = (hasCcrPrivilege, { parkObjects, ccrObjectId }) => {
    const filteredParkObjects = parkObjects.filter((parkObject) => parkObject.shownInOperations);
    const allowedRoutes = filteredParkObjects.flatMap(parkToRoutes);
    const allowedScreens = getAllowedScreens(filteredParkObjects);

    if (hasCcrPrivilege) {
        const portfolioKey = PARK_PORTFOLIO_KEY.toLowerCase();

        // Add Fake park for Park Menu named Portfolio with Offshore Activity and Operations Commercial as allowed screens
        allowedRoutes.push({ url: `/${portfolioKey}/${PATH_OFFSHORE_ACTIVITY}` });
        allowedRoutes.push({ url: `/${portfolioKey}/${PATH_OPERATIONS_COMMERCIAL}` });

        allowedScreens[portfolioKey] = [
            ...(allowedScreens[portfolioKey] || []),
            PATH_OFFSHORE_ACTIVITY,
            PATH_OPERATIONS_COMMERCIAL,
        ];
    }

    Logger.debug('Allowed routes:', allowedRoutes);
    Logger.debug('Park screens:', allowedScreens);
    return {
        allowedRoutes, // example: [{ url: '/gym/operations' }, { url: 'gym/reports' }],
        allowedScreens, // example: { gym: ['operations', 'reports'], galloper: ['operations', 'reports'] },
    };
};
